import React, { Component } from 'react';
import { Route } from 'react-router-dom';

import List from './List';
import Sources from './Sources';
import NewArticle from './NewArticle';
import EditArticle from './EditArticle';
import EditSourceArticle from './EditSourceArticle';

class Container extends Component {
  render() {
    return (
      <div id="news">
        <Route exact path="/news" component={List} />
        <Route exact path="/news/sources" component={Sources} />
        <Route exact path="/news/sources/:idx/edit" component={EditSourceArticle} />
        <Route exact path="/news/new" component={NewArticle} />
        <Route exact path="/news/:id/edit" component={EditArticle} />
      </div>
    );
  }
}

export default Container;
